import { ReactComponent as FlagIcon } from "./svg/hr-flag.svg";
import "../flag-icon.scss";

export const HRFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
